export default class PostSignatureBodyAPIModel {
  signature_base64: string;
  signature_record: any;

  constructor(signatureBase64: string, signatureRecordAPI: any) {
    this.signature_base64 = signatureBase64;
    this.signature_record = signatureRecordAPI;
  }
}
